import { NotiflySettings, NotiflyType } from '@project/shared-types';
import { useCallback, useEffect, useState } from 'react';
import { NotiflyGetAPI, NotiflyUpdateAPI } from '../../model/notifly.api';

type Channel = 'telegram' | 'email';

const CHANNELS: Record<number, Channel> = {
    0: 'telegram',
    1: 'email'
};

export const useNotiflySettings = () => {
    const [settings, setSettings] = useState<NotiflySettings>();

    const getSettings = useCallback(async () => {
        try {
            const response = await NotiflyGetAPI();
            if (response?.settings) {
                setSettings(response.settings);
            }
        } catch (error) {
            console.error('Ошибка при получении настроек:', error);
        }
    }, []);

    useEffect(() => {
        getSettings();
    }, [getSettings]);

    const changeSection = useCallback(async (tab: number, section: NotiflyType) => {
        const channel = CHANNELS[tab];
        if (!channel || !settings) return;

        const updatedSettings = {
            ...settings,
            options: {
                ...settings.options,
                [channel]: settings.options[channel].map(setting =>
                    setting.type === section
                        ? { ...setting, enabled: !setting.enabled }
                        : setting
                )
            }
        };

        setSettings(updatedSettings);

        try {
            const response = await NotiflyUpdateAPI({
                patch: updatedSettings.options
            });
            if (response?.settings && response.settings !== updatedSettings) {
                setSettings(response.settings);
            }
        } catch (error) {
            console.error('Ошибка при обновлении настроек:', error);
            // Возвращаем предыдущее состояние при ошибке
            setSettings(settings);
        }
    }, [settings]);

    const getSettingsByTab = useCallback((tab: number) => {
        const channel = CHANNELS[tab];
        return settings?.options[channel];
    }, [settings]);

    return {
        settings,
        changeSection,
        getSettingsByTab,
    };
};